import axios from '../axiosConfig';

export default {
  getConfigurations: () => axios.get('/configurations').then((res)=> res.data),
  updateConfiguration : (request) => axios.put('/configurations', request).then((res)=> res.data),
};
